import { useEffect, useRef } from 'react';

import style from './ClickOutsideAlerter.module.scss';

interface Props {
    inheritSize?: boolean;
    children: React.ReactNode | React.ReactNode[];
    onClickOutside?(event?: any): void;
}

export function ClickOutsideAlerter({ inheritSize, children, onClickOutside }: Props) {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node) && onClickOutside) {
                onClickOutside(event);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [onClickOutside]);

    return (
        <div
            ref={wrapperRef}
            className={inheritSize ? style.root : undefined}
        >
            {children}
        </div>
    );
}
